import React from "react";
// import Banner from '../../components/UserSideComponents/howitworks/Banner'
import Works from "../../components/UserSideComponents/howitworks/HowItWorks";
import Banner from "../../components/UserSideComponents/abouts/Banner";
const HowItWorks = () => {
  return (
    <>
      <Banner title="How It Works" />
      <Works />
    </>
  );
};

export default HowItWorks;
